import { getInstance } from '../StateManager';
import { lastItem } from 'Misc/collections';
import { HOST } from 'StateEvents';
import Updater from './Updater';

export default class HostUpdater extends Updater {
  constructor() {
    super();
    this.addRelevant(HOST);
  }

  updateState(newState, event) {
    switch(event.name) {
      case HOST.MESSAGE_SENT:
        newState.host.sent = newState.host.sent.concat(...event.args);
        break;
      case HOST.MESSAGE_RECEIVED:

        // Leaving this code for now. It should be used to compress
        // repeated events when sending the state over the wire
        // 
        // const lastMessage = lastItem(newState.host.received);

        // if(lastMessage && lastMessage.indexOf(event.fn) > -1) {
        //   const currentIncrement = lastMessage.match(/([0-9]+)/);

        //   if(currentIncrement) {
        //     event.fn += Number(currentIncrement[0]) + 1;
        //   } else {
        //     event.fn += 1;
        //   }

        //   newState.host.received = newState.host.received.map( message => message === lastMessage ? event.fn : message );
        // } else {
        //   newState.host.received = newState.host.received.concat(event.fn);
        // }

        newState.host.received = newState.host.received.concat(event.fn);
        newState = this.processCall(newState, event);
        break;
    }

    return newState;
  }

  processCall(newState, { fn, args }) {
    switch(fn) {
      case 'initAd':
        newState.host = 
          ['width', 'height', 'viewMode', 'bitrate', 'creativeData', 'environmentVars']
            .reduce( (host, key, i) => {
              host[key] = args[i];
              return host;
            }, newState.host);
        newState.display.container = newState.host.environmentVars.slot;
        newState.display.viewMode  = newState.host.viewMode;
        newState.media.element     = this.getVideoElement(newState.host.environmentVars.videoSlot, newState.host);
        break;
      case 'pauseAd':
        newState.media.paused = true;
        break;
      case 'resumeAd':
        newState.media.paused = false;
        break;
      case 'skipAd':
        newState.media.skipped = true;
        break;
      case 'stopAd':
        newState.media.stopped = true;
        break;
      case 'resizeAd':
        newState.display.width    = args[0];
        newState.display.height   = args[1];
        newState.display.viewMode = args[2];
        break;
      case 'setSize' :
        newState.display.width    = args[0];
        newState.display.height   = args[1];
        break;
      case 'setAdVolume':
        newState.media.volume = args[0];
        break;
    }

    return newState;
  }

  getVideoElement(providedElement, { environmentVars, width, height }) {
    if(!providedElement) {
      providedElement = document.createElement('video');
      providedElement.setAttribute('playsinline', true);
      providedElement.style.position = 'absolute';
      providedElement.style.width    = width;
      providedElement.style.height   = height;
      providedElement.style.left     = 0;
      providedElement.style.top      = 0;
      providedElement.style.zIndex   = 0;
      environmentVars.slot.appendChild(providedElement);
    }

    return providedElement;
  }
}

getInstance().registerUpdater(new HostUpdater());


// WEBPACK FOOTER //
// ./src/Services/State/Updaters/HostUpdater.js